import apiService from '../service/apiService';
import * as UtilityFunctions from '../HelperMethods/UtilityFunctions';

export const types = {
  LOAD_TASK_TYPES_SUCCESS: 'LOAD_TASK_TYPES_SUCCESS',
  TASK_TYPES_LOADING_START: 'TASK_TYPES_LOADING_START',
  CREATE_TASK_TYPE_SUCCESS: 'CREATE_TASK_TYPE_SUCCESS',
  UPDATE_TASK_TYPE_SUCCESS: 'UPDATE_TASK_TYPE_SUCCESS',
  DELETE_TASK_TYPE_SUCCESS: 'DELETE_TASK_TYPE_SUCCESS',
  TASK_TYPES_LOADING_STOP: 'TASK_TYPES_LOADING_STOP',
  LOADING_TASK_TYPE_ENTITY: 'LOADING_TASK_TYPE_ENTITY',
};

export function loadTaskTypesSuccess(response) {
  const taskTypes = response.data.searchTaskTypes.items.map((taskType) => {
    taskType.schema = JSON.parse(taskType.schema);
    if (taskType && taskType.priorityAlias) {
      taskType.priorityAlias = UtilityFunctions.parseJSONStringToObject(taskType.priorityAlias);
    }
    return taskType;
  });
  return { type: types.LOAD_TASK_TYPES_SUCCESS, taskTypes };
}

export function loadAllTaskTypes(fieldId) {
  return (dispatch) => {
    dispatch({ type: types.TASK_TYPES_LOADING_START });
    const paramObject = UtilityFunctions.getSearchGraphQLParamForFieldId(fieldId);
    return apiService
      .searchTaskTypes(paramObject)
      .then((response) => {
        dispatch(loadTaskTypesSuccess(response));
      })
      .catch((error) => {
        throw error;
      });
  };
}

export function createTaskTypeSuccess(response) {
  return (dispatch) => {
    const taskType = response.data.createTaskType || response.data.onCreateTaskType;
    taskType.schema = JSON.parse(taskType.schema);
    if (taskType && taskType.priorityAlias) {
      taskType.priorityAlias = UtilityFunctions.parseJSONStringToObject(taskType.priorityAlias);
    }
    dispatch({ type: types.CREATE_TASK_TYPE_SUCCESS, taskType });
    return taskType;
  };
}

export function createTaskType(taskType) {
  taskType.isDeleted = false;
  return (dispatch) => {
    return apiService.createTaskType(taskType).then((savedTaskType) => {
      return dispatch(createTaskTypeSuccess(savedTaskType));
    });
  };
}
function updateTaskTypeSuccess(response) {
  return (dispatch) => {
    const taskType = response.data.updateTaskType || response.data.onUpdateTaskType;
    taskType.schema = JSON.parse(taskType.schema);
    if (taskType && taskType.priorityAlias) {
      taskType.priorityAlias = UtilityFunctions.parseJSONStringToObject(taskType.priorityAlias);
    }
    dispatch({ type: types.UPDATE_TASK_TYPE_SUCCESS, taskType });
    return taskType;
  };
}

export function updateTaskType(taskType) {
  taskType.isDeleted = false;
  return (dispatch) => {
    return apiService.updateTaskType(taskType).then((response) => {
      return dispatch(updateTaskTypeSuccess(response));
    });
  };
}

export const searchTaskTypeById = (id) => {
  return (dispatch) => {
    dispatch({ type: types.LOADING_TASK_TYPE_ENTITY });
    return apiService
      .getTaskTypeById(id)
      .then((response) => {
        response.data.getTaskType.schema = JSON.parse(
          response.data && response.data.getTaskType && response.data.getTaskType.schema
        );
        dispatch({ type: types.TASK_TYPES_LOADING_STOP });
        return response.data && response.data.getTaskType;
      })
      .catch((error) => {
        throw error;
      });
  };
};

export const taskTypeLoadingStop = () => {
  return (dispatch) => {
    dispatch({ type: types.TASK_TYPES_LOADING_STOP });
  };
};
